import * as React from 'react'
import * as loadImage from 'blueimp-load-image'
import { uniqueId } from 'lodash'

export interface Props {
  type: 'text' | 'photo'
  photo?: string
  onSubmit?: (message: string) => void
  onClearPhoto?: () => void
  onUploadPhoto?: (photo: string, note: string) => void
}

interface State {
  message: string
  photo?: string
}

export default class MediaInput extends React.Component<Props, State> {
  private photoLoadingID: string | null = null
  constructor (props: any, context?: any) {
    super(props, context)
    this.state = {
      message: ''
    }
    if (props.photo) {
      this.updatePhoto(props.photo)
    }
  }

  componentWillUpdate (nextProps: Props) {
    if (this.props.photo !== nextProps.photo) {
      this.updatePhoto(nextProps.photo)
    }
  }

  render () {
    const style: React.CSSProperties = {
      position: 'absolute',
      bottom: '10px',
      left: '10px',
      right: '10px',
      marginBottom: '50px',
      zIndex: 10000
    }

    let input: JSX.Element | null = null
    switch (this.props.type) {
      case 'text':
        input = (
          <input
            className='block border rounded bg-white p1 mx-auto'
            style={{ fontSize: '16px', maxWidth: '1000px', width: '80%' }}
            value={this.state.message}
            placeholder='Say something here'
            onChange={this._onChange}
          />
        )
        break
      case 'photo':
        input = (
          <div
            className='relative flex mx-auto'
            style={{ maxWidth: '1000px', width: '80%' }}>
            <div
              className='absolute flex items-center justify-center mr2'
              style={{ left: '10px', height: '100%' }}>
              <div className='relative'>
                <i
                  className='fa fa-times-circle-o fa-2x absolute'
                  style={{ right: '-10px', top: '-10px' }}
                  onClick={this.onClearPhoto}
                />
                <img
                  src={this.state.photo}
                  style={{
                    maxWidth: '64px',
                    maxHeight: '64px',
                    padding: '4px'
                  }}
                />
              </div>
            </div>
            <input
              value={this.state.message}
              placeholder='Note for image'
              className='border rounded bg-white flex-auto mr2'
              style={{
                height: '100px',
                paddingLeft: '100px',
                paddingRight: '20px',
                fontSize: '16px'
              }}
              onChange={this._onChange}
            />
            <input value='Post' type='submit' className='btn btn-primary' />
          </div>
        )
        break
    }
    return (
      <div style={style}>
        <form onSubmit={this._onSubmit}>{input}</form>
      </div>
    )
  }

  private updatePhoto (newPhoto?: string) {
    const loadingID = uniqueId()
    this.photoLoadingID = loadingID
    if (!newPhoto) {
      this.setState({ photo: undefined })
      return
    }
    const mime = newPhoto.substr(
      newPhoto.indexOf(':') + 1,
      newPhoto.indexOf(';')
    )
    loadImage(
      newPhoto,
      (image: HTMLCanvasElement) => {
        // update photo task canceled
        if (loadingID !== this.photoLoadingID) {
          return
        }
        const dataURL = image.toDataURL(mime)
        this.setState({ photo: dataURL })
      },
      {
        orientation: true,
        canvas: true,
        maxWidth: 64,
        maxHeight: 64,
        pixelRatio: 2
      }
    )
  }

  private _onChange = (event: React.FormEvent<HTMLInputElement>) => {
    // copy value before it's gone
    const value = event.currentTarget.value
    this.setState(state => {
      return {
        ...state,
        message: value
      }
    })
  }

  private onClearPhoto = () => {
    if (this.props.onClearPhoto) {
      this.props.onClearPhoto()
    }
  }

  private _onSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault()
    if (this.props.type === 'photo') {
      if (this.props.onUploadPhoto) {
        this.props.onUploadPhoto(this.props.photo!, this.state.message)
        this.setState({ message: '' })
      }
      return
    }
    if (this.props.onSubmit) {
      this.props.onSubmit(this.state.message)
    }
    this.setState(state => {
      return {
        ...state,
        message: '',
        photo: undefined
      }
    })
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/MediaInput.tsx